import { createBrowserRouter, Outlet } from 'react-router-dom'
import { ProtectedRoute, RedirectIfAuthenticated } from '#/integrations/auth-provider'

// Lazy imports for page components
const LoginPage = () => import('#/routes/login/index').then((m) => ({ Component: m.default }))
const DashboardLayout = () => import('#/routes/_dashboard').then((m) => ({ Component: m.default }))
const DashboardPage = () =>
  import('#/routes/dashboard/dashboard').then((m) => ({ Component: m.default }))
const DramaListPage = () =>
  import('#/routes/dashboard/content/drama/index').then((m) => ({ Component: m.default }))
const CreateDramaPage = () =>
  import('#/routes/dashboard/content/drama/new').then((m) => ({ Component: m.default }))
const EditDramaPage = () =>
  import('#/routes/dashboard/content/drama/$id.edit').then((m) => ({ Component: m.default }))
const DramaDetailPage = () =>
  import('#/routes/dashboard/content/drama/$dramaId').then((m) => ({ Component: m.default }))
const EpisodeListPage = () =>
  import('#/routes/dashboard/content/episode/index').then((m) => ({ Component: m.default }))
const CreateEpisodePage = () =>
  import('#/routes/dashboard/content/episode/new').then((m) => ({ Component: m.default }))
const EditEpisodePage = () =>
  import('#/routes/dashboard/content/episode/$id.edit').then((m) => ({ Component: m.default }))
const GenreListPage = () =>
  import('#/routes/dashboard/content/genre/index').then((m) => ({ Component: m.default }))
const TelegramContentPage = () =>
  import('#/routes/dashboard/content/telegram/index').then((m) => ({ Component: m.default }))
const BannerListPage = () =>
  import('#/routes/dashboard/marketing/banner/index').then((m) => ({ Component: m.default }))
const CreateBannerPage = () =>
  import('#/routes/dashboard/marketing/banner/new').then((m) => ({ Component: m.default }))
const BannerDetailPage = () =>
  import('#/routes/dashboard/marketing/banner/$id').then((m) => ({ Component: m.default }))
const AdminListPage = () =>
  import('#/routes/dashboard/user/admin/index').then((m) => ({ Component: m.default }))
const CreateAdminPage = () =>
  import('#/routes/dashboard/user/admin/new').then((m) => ({ Component: m.default }))
const EditAdminPage = () =>
  import('#/routes/dashboard/user/admin/$id.edit').then((m) => ({ Component: m.default }))
const UserListPage = () =>
  import('#/routes/dashboard/user/user').then((m) => ({ Component: m.default }))
const UserDetailPage = () =>
  import('#/routes/dashboard/user/$id').then((m) => ({ Component: m.default }))
const TransactionListPage = () =>
  import('#/routes/dashboard/finance/transactions').then((m) => ({ Component: m.default }))
const PurchaseListPage = () =>
  import('#/routes/dashboard/finance/purchases').then((m) => ({ Component: m.default }))
const SystemSettingsPage = () =>
  import('#/routes/dashboard/settings/system').then((m) => ({ Component: m.default }))

// Guard wrapper components for use as route elements
function GuestLayout() {
  return (
    <RedirectIfAuthenticated>
      <Outlet />
    </RedirectIfAuthenticated>
  )
}

function AuthLayout() {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  )
}

export const router = createBrowserRouter([
  {
    element: <GuestLayout />,
    children: [{ path: '/', lazy: LoginPage }],
  },
  {
    element: <AuthLayout />,
    children: [
      {
        lazy: DashboardLayout,
        children: [
          { path: 'dashboard', lazy: DashboardPage },
          // Content
          { path: 'content/drama', lazy: DramaListPage },
          { path: 'content/drama/new', lazy: CreateDramaPage },
          { path: 'content/drama/:id/edit', lazy: EditDramaPage },
          { path: 'content/drama/:dramaId', lazy: DramaDetailPage },
          { path: 'content/episode', lazy: EpisodeListPage },
          { path: 'content/episode/new', lazy: CreateEpisodePage },
          { path: 'content/episode/:id/edit', lazy: EditEpisodePage },
          { path: 'content/genre', lazy: GenreListPage },
          { path: 'content/telegram', lazy: TelegramContentPage },
          // Marketing
          { path: 'marketing/banner', lazy: BannerListPage },
          { path: 'marketing/banner/new', lazy: CreateBannerPage },
          { path: 'marketing/banner/:id', lazy: BannerDetailPage },
          // User
          { path: 'user/admin', lazy: AdminListPage },
          { path: 'user/admin/new', lazy: CreateAdminPage },
          { path: 'user/admin/:id/edit', lazy: EditAdminPage },
          { path: 'user/user', lazy: UserListPage },
          { path: 'user/user/:id', lazy: UserDetailPage },
          // Finance
          { path: 'finance/transactions', lazy: TransactionListPage },
          { path: 'finance/purchases', lazy: PurchaseListPage },
          // Settings
          { path: 'settings/system', lazy: SystemSettingsPage },
        ],
      },
    ],
  },
])
